import { render, staticRenderFns } from "./interviewText.vue?vue&type=template&id=97dd2b50&scoped=true"
import script from "./interviewText.vue?vue&type=script&lang=js"
export * from "./interviewText.vue?vue&type=script&lang=js"
import style0 from "./interviewText.vue?vue&type=style&index=0&id=97dd2b50&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97dd2b50",
  null
  
)

export default component.exports